import { render, staticRenderFns } from "./AgentPermissionsApps.vue?vue&type=template&id=7a0f34b7"
import script from "./AgentPermissionsApps.vue?vue&type=script&lang=js"
export * from "./AgentPermissionsApps.vue?vue&type=script&lang=js"
import style0 from "./AgentPermissionsApps.vue?vue&type=style&index=0&id=7a0f34b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports